
import { combineReducers } from "redux";
import filter from "./FilterReducer";
import general from "./GeneralReducer";
import map from "./MapReducer";
import search from "./SearchReducer";

export default combineReducers({ filter, general, map, search });
